<template>
  <div :class="[
    'mobile-menu-header q-px-lg q-py-none flex justify-end items-center',
    logo ? 'justify-between' : 'justify-end',
  ]">
    <img
      v-if="logo"
      :src="logo"
      :width="logoAttributes.width"
      :height="logoAttributes.height"
      @click="router.push({ name: ROUTES.RENDER.BLOG })"
    >
    <AppBtn
      class="mobile-menu-button border-radius-10"
      :icon="buttonIcon"
      icon-size="14px"
      @click="$emit('click')"
    />
  </div>
</template>

<script setup>
import AppBtn from 'components/AppBtn.vue';
import { ROUTES } from 'src/enums';
import { useRouter } from 'vue-router';

const router = useRouter();

defineProps({
  logo: {
    type: String,
    default: undefined,
  },
  logoAttributes: {
    type: Object,
    default: () => ({}),
  },
  buttonIcon: {
    type: String,
    default: 'img:bars.svg',
  },
});
defineEmits(['click']);
</script>

<style scoped lang="scss">
.mobile-menu-header {
  height: 90px;
  border-bottom: 1px solid var(--blog-border-color, $grey-4);

  > img {
    max-height: 80px;
  }
}
.mobile-menu-button {
  width: 54px;
  height: 54px;
  background: var(--blog-card-color, #fff);
  color: var(--blog-font-color, $grey-4);
  opacity: 0.5;

  &:hover {
    color: var(--blog-primary-color, $primary);
    opacity: 1;
  }
}
</style>
